import styled from 'styled-components';
import { media } from '@belong/themes';
import { PictureContainer } from '@belong/ui-components';

export const Image = styled(PictureContainer)`
  display: block;
  width: 23rem;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;

  ${media('md')`
    width: 34.5rem;
  `}
`;
